import { FC, useRef } from "react";
import {
    Button,
    Flex,
    Box,
    useDisclosure,
    useOutsideClick,
} from "@smile2impress/components/relaunch";
import { useUTSLocaleContext } from "context/utsLocaleContext";

import { FlagIconByLocale } from "components/Icons/FlagIconByLocale";
import { isClickedOnButton } from "components/Header/components/LocationSelect/helpers";
import Link from "components/Link";

import { LocationMenu } from "../LocationMenu/LocationMenu";
import { MobileHeaderProps } from "./MobileHeader.types";

export const MobileHeader: FC<MobileHeaderProps> = ({
    candidate,
    locationSelect,
    hideMenu = false,
}) => {
    const { locale } = useUTSLocaleContext();

    const { isOpen, onToggle, onClose } = useDisclosure();

    const locationContentRef = useRef(null);

    useOutsideClick({
        ref: locationContentRef,
        handler: (e: Event) => {
            // Check if are not clicking toggle button
            if (
                e?.target &&
                !isClickedOnButton(e.target as HTMLInputElement, 3)
            )
                onClose();
        },
    });

    return (
        <>
            {!hideMenu && (
                <Flex direction="row" position={"relative"} alignItems="center">
                    {candidate?.link && (
                        <Button
                            as={Link}
                            py="12px"
                            h="28px"
                            variant="grey"
                            href={candidate.link}
                        >
                            {candidate.text}
                        </Button>
                    )}
                    <Button
                        variant="ghost"
                        onClick={onToggle}
                        width="24px"
                        p={0}
                        ml="8px"
                    >
                        <FlagIconByLocale locale={locale} />
                    </Button>

                    <Box
                        minWidth={["350px"]}
                        zIndex="dropdown"
                        position="absolute"
                        flexGrow={1}
                        top={"100%"}
                        mt={0.7}
                        right={0}
                        height={"auto"}
                        borderBottomRadius={[0, 0, "40px"]}
                        borderRadius="sm"
                        overflow="hidden"
                        justifyContent="center"
                        backgroundColor="bg.base"
                        visibility={isOpen ? "visible" : "hidden"}
                        ref={locationContentRef}
                        boxShadow="medium"
                    >
                        <LocationMenu
                            locale={locale}
                            {...locationSelect}
                            closeMenu={onClose}
                        />
                    </Box>
                </Flex>
            )}
        </>
    );
};
